import { initTracking, login, logout, logEvent, logBeconEvent, logPV, setConfig } from '@dauyan/h5-tracking';
import { getPageName } from './get-page-name';
// import { isRemote, isProduction, version } from '../env';
// import { getHashPath, getPathname } from './get-page-name';

// const updateConfig = () => {
//   setConfig({
//     release: version,
//     environment: isRemote ? (isProduction ? 'prod' : 'pre') : 'local',
//     biz_site: window.location.host,
//     biz_page: getPathname(),
//     biz_module: getHashPath(),
//     page_manual_key: `[${window.location.host}][${getPathname()}][${getHashPath()}]`,
//   });
// };

// updateConfig();

const APPID = 20005152;
initTracking(APPID, {
  autotrack: {
    track_attr: ['data-track-key', 'data-track-value'],
  },
  disable_auto_pv: true,
});

export const setLoggerUserId = (uid?: string) => {
  if (uid) {
    login(uid);
  } else {
    logout();
  }
};

export const logBDEvent = logEvent;
export const logBDBeconEvent = logBeconEvent;

let lastPage = '';

export const logBDPage = () => {
  const p = getPageName();
  if (p === lastPage) {
    return;
  }
  lastPage = p;
  setConfig({ page_key: p });
  logPV({
    page_key: p,
  });

};

export const resetUserInfo = () => {
  logout();
};

export const initLogger = () => {
  logBDPage();
  window.addEventListener('hashchange', () => {
    logBDPage();
  });
  window.addEventListener('historystatechange', () => {
    logBDPage();
  });
  window.addEventListener('popstate', () => {
    logBDPage();
  });
};

initLogger();
